module.exports = __webpack_public_path__ + "media/images/flags/1x1/eng-5378f8ad1df4d8ee7e46f3ada61a4e51.svg";